<template>
    <div id="pw-rules" class="two fields pw-rule-block" aria-live="assertive">
        <span :id="ariaStatusElementId" style="height:0; overflow:hidden; position:absolute;"></span>
        <div class="left aligned field pw-rule-container">
            <div class="pw-rule-field">
                <p id="ruleLength" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.length') }}
                </p>
            </div>
            <div class="pw-rule-field" :data-tooltip="$t('components.password.rules.validCharacters') + ' A-Z'">
                <p id="ruleUpperCase" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.upper') }}
                </p>
            </div>
            <div class="pw-rule-field" :data-tooltip="$t('components.password.rules.validCharacters') + ' a-z'">
                <p id="ruleLowerCase" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.lower') }}
                </p>
            </div>
        </div>
        <div class="left aligned field pw-rule-container">
            <div class="pw-rule-field" :data-tooltip="$t('components.password.rules.validCharacters') + ' 0-9'">
                <p id="ruleNumbers" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.numbers') }}
                </p>
            </div>
            <div class="pw-rule-field"
                 :data-tooltip="$t('components.password.rules.validCharacters') + ' ' + validCharacters">
                <p id="ruleSpecialCharacter" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.specialCharacters') }}
                </p>
            </div>
            <div class="pw-rule-field">
                <p id="ruleBannedCharacter" class="pw-rule pw-rule--grey">
                    <i class="check circle outline icon"></i>
                    {{ $t('components.password.rules.bannedCharacters') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import * as validate from '../js/validation.js'

export default {
  props: {
    password: {
      type: String
    },
    ariaStatusElementId: {
      type: String,
      default: 'aria-password-status'
    }
  },
  mounted: function () {
    this.onPasswordChange()
  },
  watch: {
    password: {
      handler () {
        this.onPasswordChange()
      }
    }
  },
  methods: {
    onPasswordChange: function () {
      const ariaStatusEl = this.getAriaStatus()
      ariaStatusEl.text('')

      this.updateLabel(validate.hasLength(this.password), $('#ruleLength'), this.$t('components.password.aria.rules.length'))
      this.updateLabel(validate.containsUppercaseCharacter(this.password), $('#ruleUpperCase'), this.$t('components.password.aria.rules.upper'))
      this.updateLabel(validate.containsLowercaseCharacter(this.password), $('#ruleLowerCase'), this.$t('components.password.aria.rules.lower'))
      this.updateLabel(validate.containsNumber(this.password), $('#ruleNumbers'), this.$t('components.password.aria.rules.numbers'))
      this.updateLabel(validate.containsValidSpecialCharacter(this.password), $('#ruleSpecialCharacter'), this.$t('components.password.aria.rules.specialCharacters'))
      this.updateLabel(!validate.containsInvalidCharacter(this.password), $('#ruleBannedCharacter'), this.$t('components.password.aria.rules.bannedCharacters'))

      if (ariaStatusEl.text() === '') {
        ariaStatusEl.text(this.$t('components.password.aria.passwordIsValid'))
      }
    },
    updateLabel: function (exp, label, errorMessage) {
      if (exp) {
        label.removeClass('pw-rule--grey').addClass('pw-rule--green')
      } else {
        if (label.hasClass('pw-rule--green')) {
          label.removeClass('pw-rule--green').addClass('pw-rule--grey')
        }
        this.appendErrorToAriaStatus(errorMessage)
      }
    },
    appendErrorToAriaStatus: function (text) {
      const errorElement = this.getAriaStatus()
      let msg = errorElement.text()
      if (!msg || msg === '') {
        msg = this.$t('components.password.aria.rules.failedRulesPrefix')
      } else {
        msg += ', '
      }
      errorElement.text(msg + text)
    },
    getAriaStatus () {
      return $('#' + this.ariaStatusElementId)
    }
  },
  computed: {
    validCharacters: function () {
      return validate.validSpecialCharactersString()
    }
  }
}
</script>

<style scoped>

    .pw-rule-field {
        clear: both;
        margin: 0;
        padding-top: 0;
        padding-bottom: 0;
    }

    .pw-rule {
        margin-left: 10px;
    }

    .pw-rule--grey {
        color: grey;
    }

    .pw-rule--green {
        color: green;
    }

    @media only screen and (max-width: 767px) {
        .ui.form .fields {
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
        }
    }

    @media (max-width: 500px) {
        .ui.form .fields {
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        }

        .ui.form .fields>.field:first-of-type {
            padding-bottom: 0;
        }

        .ui.form .fields>.field:last-of-type {
            padding-top: 0;
        }
    }

    [data-tooltip]:not([data-position]):before {
        z-index: 3 !important;
    }

    [data-tooltip]:not([data-position]):after {
        z-index: 2 !important;
    }
</style>
